import { environmentCommon } from "./environment.common";

export const environment = {
    production: true,
   dashboardEnvironment: 'demo' as const,
    common: environmentCommon,
    googleClientId: "1092854335143-e3ri3sdaptproleef3jpshg8eaniq79k.apps.googleusercontent.com",
    // dashboardApiUrl: 'https://dashboard2024-api-qaei52d5wa-ew.a.run.app/',
    dashboardApiUrl: "https://api.scientifica-platform.it/",

    // dealflowApiUrl: 'https://dealflow-api-service-645208217418.europe-west12.run.app/',
    dealflowApiUrl: 'https://dealflow-api.scientifica-platform.it/',

    firebase: {
        projectId: "scientifica-cms-backoffice",
        appId: "1:957434876993:web:382f25bd021aae483c22c0",
        storageBucket: "scientifica-cms-backoffice.appspot.com",
        locationId: "europe-west",
        apiKey: "AIzaSyAwkG1Hk7vj9pvdQdVK6yXJo2TJQgo9OiI",
        authDomain: "scientifica-cms-backoffice.firebaseapp.com",
        messagingSenderId: "957434876993"
    }
};
